export const OPTIONS_OPEN_OPERATIONS_UPDATED_EVENT = 'options-open-operations-updated';

export const emitOptionsOpenOperationsUpdated = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPTIONS_OPEN_OPERATIONS_UPDATED_EVENT));
};

export default emitOptionsOpenOperationsUpdated;